import React, { useState, useEffect } from "react";

const Header = () => {
  const [stickyMenu, setStickyMenu] = useState(false);
  const [navigationOpen, setNavigationOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setStickyMenu(window.pageYOffset > 5);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const logoLight = "assets/images/logo3.png";
  const logoDark = "assets/images/logo4.PNG";

  return (
    <header
      className={`g s r vd ya cj ${stickyMenu ? "hh sm _k dj bl ll" : ""}`}
      style={{
        backgroundColor: stickyMenu ? "white" : "transparent",
        color: stickyMenu ? "black" : "white",
        boxShadow: stickyMenu ? "0px 4px 6px rgba(0, 0, 0, 0.1)" : "none",
        transition: "all 0.3s ease",
      }}
    >
      <div className="bb ze ki xn 2xl:ud-px-0 oo wf yf i">
        <div className="vd tc wf yf">
          <a href="/">
            <img
              className="om"
              src={stickyMenu ? logoDark : logoLight}
              alt="Logo"
              style={{ height: "70px", transition: "opacity 0.3s ease" }}
            />
          </a>

          <button className="po rc" onClick={() => setNavigationOpen(!navigationOpen)}>
            <span className="rc i pf re pd">
              <span className="du-block h q vd yc">
                <span className={`rc i r s eh um tg te rd eb ml jl dl ${!navigationOpen ? "ue el" : ""}`}></span>
                <span className={`rc i r s eh um tg te rd eb ml jl fl ${!navigationOpen ? "ue qr" : ""}`}></span>
                <span className={`rc i r s eh um tg te rd eb ml jl gl ${!navigationOpen ? "ue hl" : ""}`}></span>
              </span>
            </span>
          </button>
        </div>

        <div className={`vd sd qo f ho oo wf yf ${navigationOpen ? "d hh rm sr td ud qg ug jc yh" : ""}`}>
          <nav>
            <ul className="tc _o sf yo cg ep">
              <li>
                <a href="/" className="xl" style={{ color: isMobile ? "black" : stickyMenu ? "black" : "white" }}>
                  Home
                </a>
              </li>

              <li>
                <a href="/about" className="xl" style={{ color: isMobile ? "black" : stickyMenu ? "black" : "white" }}>
                  About
                </a>
              </li>
              <li className="c i" style={{ position: "relative" }}>
                <a
                  href="#"
                  className="xl tc wf yf bg"
                  onClick={(e) => {
                    e.preventDefault();
                    setDropdown(!dropdown);
                  }}
                 style={{ color: isMobile ? "black" : stickyMenu ? "black" : "white" }}
                >
                  Gallery
                  <svg
                    className={`th mm we fd pf ${dropdown ? "wh" : ""}`}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                  </svg>
                </a>
                {dropdown && (
                  <ul
                    className="a tc"
                    style={{
                      backgroundColor: stickyMenu ? "white" : "rgba(0, 0, 0, 0.85)",
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      padding: "10px 20px",
                      zIndex: 999,
                      borderRadius: "6px",
                    }}
                  >
                    <li>
                      <a href="/bridal" className="xl" style={{ color: stickyMenu ? "black" : "white" }}>
                        Bridal
                      </a>
                    </li>
                    <li>
                      <a href="/couple" className="xl" style={{ color: stickyMenu ? "black" : "white" }}>
                        Couples
                      </a>
                    </li>
                    <li>
                      <a href="/haldi" className="xl" style={{ color: stickyMenu ? "black" : "white" }}>
                        Haldi
                      </a>
                    </li>
                    <li>
                      <a href="/wedding" className="xl" style={{ color: stickyMenu ? "black" : "white" }}>
                        Wedding
                      </a>
                    </li>
                    <li>
                      <a href="/pre-wedding" className="xl" style={{ color: stickyMenu ? "black" : "white" }}>
                        Pre Wedding
                      </a>
                    </li>
                    <li>
                      <a href="/model" className="xl" style={{ color: stickyMenu ? "black" : "white" }}>
                        Model
                      </a>
                    </li>
                    <li>
                      <a href="/gallery" className="xl" style={{ color: stickyMenu ? "black" : "white" }}>
                        All
                      </a>
                    </li>
                  </ul>
                )}
              </li>
              <li>
                <a href="/contact" className="xl" style={{ color: isMobile ? "black" : stickyMenu ? "black" : "white" }}>
                  Contact
                </a>
              </li>
            </ul>
          </nav>

          <div className="tc wf ig pb no">
            <div className={`pc h io pa ra ${navigationOpen ? "!-ud-visible" : "d"}`}>
              <label className="rc ab i">
                <input
                  type="checkbox"
                  checked={darkMode}
                  onChange={() => setDarkMode(!darkMode)}
                  className="pf vd yc uk h r za ab"
                />
                <img className="xc nm" src="images/icon-moon.svg" alt="Moon" />
              </label>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
